import { render, staticRenderFns } from "./Competitions.vue?vue&type=template&id=187675e3"
import script from "./Competitions.vue?vue&type=script&lang=js"
export * from "./Competitions.vue?vue&type=script&lang=js"
import style0 from "./Competitions.vue?vue&type=style&index=0&id=187675e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports